"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const WorkflowIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props, { viewBox: "0 0 100 100" }),
    react_1.default.createElement("path", { d: "M83.55,3a4.9,4.9,0,0,0-7,0L62.62,16.89a4.91,4.91,0,0,0,0,7L76.53,37.81a4.9,4.9,0,0,0,7,0L97.46,23.9a4.91,4.91,0,0,0,0-7Z" }),
    react_1.default.createElement("path", { d: "M18.47,3a17.4,17.4,0,1,0,17.4,17.4A17.42,17.42,0,0,0,18.47,3Z" }),
    react_1.default.createElement("polygon", { points: "45.48 15.76 48.03 17.89 38.8 17.89 38.8 22.89 48.03 22.89 45.48 25.02 48.69 28.86 58.81 20.39 48.69 11.93 45.48 15.76" }),
    react_1.default.createElement("polygon", { points: "77.54 42 77.54 51.22 75.41 48.67 71.57 51.88 80.04 62 88.51 51.88 84.67 48.67 82.54 51.22 82.54 42 77.54 42" }),
    react_1.default.createElement("rect", { x: "3.55", y: "66.18", width: "29.84", height: "29.84" }),
    react_1.default.createElement("path", { d: "M80,63.69a17.4,17.4,0,1,0,17.4,17.4A17.42,17.42,0,0,0,80,63.69Z" }),
    react_1.default.createElement("polygon", { points: "52.13 76.47 48.92 72.63 38.8 81.09 48.92 89.56 52.13 85.73 49.59 83.59 58.81 83.59 58.81 78.59 49.59 78.59 52.13 76.47" })));
exports.WorkflowIcon = WorkflowIcon;
exports.default = exports.WorkflowIcon;
